import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { WrapupPanelService } from './wrapup-panel.service';
import { WrapUpPanelComponent } from './wrap-up-panel.component';
import { FormFieldModule } from './form-field/form-field.module';
import { FormsModule } from '@angular/forms';
import { BcSafeSender } from 'common/auth/safe-sender.service';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    FormFieldModule,
    FormsModule
  ],
  providers: [
    WrapupPanelService,
    BcSafeSender
  ],
  declarations: [
    WrapUpPanelComponent
  ],
  exports: [
    WrapUpPanelComponent
  ]
})
export class WrapUpPanelModule {}
